// Crossfades images by stacking opaque layers inside a container. Each new
// layer waits for its image to decode, fades in on top, then removes everything
// beneath it. Nothing underneath changes mid-fade, so interrupting a fade (a
// fast sweep across thumbnails) still blends continuously instead of snapping.
//
// Classes used here must also appear in a .liquid file: Tailwind only scans
// Liquid sources, not assets/*.js.
class ImageCrossfade {
  static DURATION = 450;

  constructor(container) {
    this.container = container;
    this.layers = [];
  }

  get active() {
    return this.layers.length > 0;
  }

  show(layer) {
    layer.classList.add('opacity-0', 'transition-opacity', 'duration-450');
    this.container.appendChild(layer);
    this.layers.push(layer);

    const img = layer.tagName === 'IMG' ? layer : layer.querySelector('img');
    const ready = img ? img.decode().catch(() => {}) : Promise.resolve();

    ready.then(() => {
      if (!layer.isConnected || layer.dataset.leaving) return;
      // The global hide-until-loaded rule would keep it invisible otherwise.
      if (img) img.classList.add('is-loaded');
      void layer.offsetWidth; // commit opacity 0 so the change transitions
      layer.classList.remove('opacity-0');

      setTimeout(() => {
        const index = this.layers.indexOf(layer);
        if (index <= 0) return;
        this.layers.splice(0, index).forEach((old) => old.remove());
      }, ImageCrossfade.DURATION);
    });
  }

  // Fade back to whatever sits beneath the layers.
  clear() {
    this.layers.forEach((layer) => {
      layer.dataset.leaving = 'true';
      if (layer.classList.contains('opacity-0')) {
        // Still waiting on decode — never shown.
        layer.remove();
        return;
      }
      layer.classList.add('opacity-0');
      setTimeout(() => layer.remove(), ImageCrossfade.DURATION);
    });
    this.layers = [];
  }
}

window.ImageCrossfade = ImageCrossfade;
